import loginApi from './modules/login';
import userApi from './modules/user';
import staff from './modules/staff';
import openWeapp from './modules/openWeapp';
export default {
  //用户相关的api
  ...userApi,
  ...loginApi,
  ...staff,
  ...openWeapp,
};
